import React, { FC } from 'react';
import { ColorFunction } from '@styles/colors/types';
import TouchableElement from '@components/common/touchableElement';
import { View } from 'react-native';
import { scale as initialScale } from '@components/frame';
import { ICON_BUTTON_PADDING } from '@v2/pages/common/constants/base.constants';
import Svg from '@styles/icons/svg';
import { isPhone, isWeb } from '@helpers';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { SimpleOnPress } from '@interfaces/base';

interface CloseButtonProps extends SimpleOnPress {
  C: ColorFunction;
  scale?: ScaleFunction;
  takeIconForPhone?: boolean;
  testID?: string;
}

const CloseButton: FC<CloseButtonProps> = ({ C, onPress, scale = initialScale, takeIconForPhone, testID }) => {
  return (
    <TouchableElement testID={testID} onPress={onPress}>
      {({ boxStyle, pressHoverColor }) => (
        <View
          style={[
            boxStyle,
            {
              backgroundColor: C(pressHoverColor('Button/Light/Only Text')),
              padding: scale(ICON_BUTTON_PADDING),
              borderRadius: scale(18),
            },
            isWeb && { outline: 'none' },
          ]}
        >
          <Svg icon={!isPhone && !takeIconForPhone ? 'closeBold' : 'close'} width={scale(20)} height={scale(20)} color={'Button/Light/Primary'} />
        </View>
      )}
    </TouchableElement>
  );
};

export default CloseButton;
